const callback = (entries) => {
    entries.forEach(({ target, isIntersecting } )=> {
      if (!isIntersecting) {
        return;
      }
      target.classList.add('show-section');
      observer.unobserve(target);
    })
  };
  
  const observer = new IntersectionObserver(callback, {
    threshold: 0.1
  });
  
  document.querySelectorAll(".animate-section").forEach(el => observer.observe(el));
  